module.exports = __webpack_public_path__ + "img/REG_ALIM_DEFAUT_STANDARD.3bbdd5f6.svg";